import { computed, inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { DocumentCenterStore } from '../../store/document/document-center.store';
import { toObservable } from '@angular/core/rxjs-interop';
import { filter, map, take } from 'rxjs';

export const documentsByProviderResolver: ResolveFn<any> = (route, state) => {
  const documentCenterStore = inject(DocumentCenterStore)

  documentCenterStore.getDocumentsByProvider()

  return toObservable(
    computed(() => ({
      status: documentCenterStore.documentCenterStatus()
    }))
  ).pipe(
    filter(({status}) => status === 'success' || status === 'error'),
    take(1)
  )
};
